import { render, staticRenderFns } from "./AzPersonsTopSlot.vue?vue&type=template&id=5c7c0ab0"
import script from "./AzPersonsTopSlot.vue?vue&type=script&lang=js"
export * from "./AzPersonsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports